import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 54,
    seconds: 39
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };else if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };else if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  const Digit = ({
    value
  }: {
    value: number;
  }) => <div className="bg-[#1a1611] px-3 py-2 md:px-6 md:py-4 rounded-lg md:rounded-xl border-2 border-[#c9a961]/30 min-w-[64px] md:min-w-[110px] relative overflow-hidden shadow-inner" data-id="element-69">
      <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" data-id="element-70"></div>
      <div className="absolute top-1/2 left-0 w-full h-px bg-black/50" data-id="element-71"></div>
      <AnimatePresence mode="popLayout" data-id="element-72">
        <motion.span key={value} initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: -20,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="block" data-id="element-73">
          {formatTime(value)}
        </motion.span>
      </AnimatePresence>
    </div>;
  return <section className="py-6 md:py-12 px-4 max-w-4xl mx-auto" data-id="element-74">
      <FadeIn data-id="element-75">
        <div className="text-center mb-4 md:mb-8" data-id="element-76">
          <h2 className="text-lg md:text-3xl font-black text-[#1a1611] flex items-center justify-center gap-2 md:gap-3 tracking-widest" data-id="element-77">
            <span className="text-2xl md:text-3xl animate-bounce" data-id="element-78">⏰</span>{' '}
            PRECIO DE LANZAMIENTO
          </h2>
        </div>

        <div className="bg-[#0a0a0a] border-2 border-[#b91c1c]/50 rounded-2xl md:rounded-3xl p-5 md:p-12 text-center relative overflow-hidden shadow-[0_20px_50px_rgba(10,10,10,0.2)]" data-id="element-79">
          <motion.div animate={{
          backgroundPosition: ['0% 0%', '100% 0%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} className="absolute top-0 left-0 w-full h-2 bg-[linear-gradient(90deg,#b91c1c,#c9a961,#b91c1c,#c9a961)] bg-[length:200%_100%]" data-id="element-80"></motion.div>

          <div className="flex justify-center items-center gap-1.5 md:gap-4 text-4xl md:text-7xl font-black font-mono mb-5 md:mb-10 text-white" data-id="element-81">
            <Digit value={timeLeft.hours} data-id="element-82" />
            <span className="text-[#c9a961] pb-2 animate-pulse" data-id="element-83">:</span>
            <Digit value={timeLeft.minutes} data-id="element-84" />
            <span className="text-[#c9a961] pb-2 animate-pulse" data-id="element-85">:</span>
            <div className="text-[#b91c1c] drop-shadow-[0_0_10px_rgba(185,28,28,0.5)]" data-id="element-86">
              <Digit value={timeLeft.seconds} data-id="element-87" />
            </div>
          </div>

          <div className="space-y-4 md:space-y-8" data-id="element-88">
            <div className="inline-flex items-center justify-center gap-2 md:gap-3 bg-[#b91c1c]/10 border border-[#b91c1c]/20 px-4 md:px-6 py-2 md:py-3 rounded-full" data-id="element-89">
              <AlertTriangle className="text-[#c9a961] w-4 h-4 md:w-6 md:h-6" data-id="element-90" />
              <p className="text-sm md:text-xl font-bold text-[#c9a961]" data-id="element-91">
                Después sube $10.000 ARS. No vuelve.
              </p>
            </div>

            <div className="max-w-xl mx-auto bg-[#1a1611] p-4 md:p-6 rounded-xl md:rounded-2xl border border-[#c9a961]/20" data-id="element-92">
              <div className="flex justify-between text-xs md:text-base font-bold mb-2 md:mb-3 text-[#e8dfd0] uppercase tracking-wider" data-id="element-93">
                <span className="flex items-center gap-2" data-id="element-94">
                  <span className="w-3 h-3 rounded-full bg-[#b91c1c] animate-pulse shadow-[0_0_10px_rgba(185,28,28,0.8)]" data-id="element-95"></span>
                  Cupos tomados
                </span>
                <span className="text-[#b91c1c]" data-id="element-96">78%</span>
              </div>
              <div className="w-full bg-[#0a0a0a] rounded-full h-3 md:h-4 overflow-hidden border border-[#c9a961]/20 relative" data-id="element-97">
                <motion.div initial={{
                width: 0
              }} animate={{
                width: '78%'
              }} transition={{
                duration: 1.5,
                ease: 'easeOut'
              }} className="h-full rounded-full bg-[#b91c1c] relative overflow-hidden" data-id="element-98">
                  <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.2)_25%,rgba(255,255,255,0.2)_50%,transparent_50%,transparent_75%,rgba(255,255,255,0.2)_75%,rgba(255,255,255,0.2)_100%)] bg-[length:20px_20px] animate-[progress-stripes_1s_linear_infinite]" data-id="element-99"></div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
      <style data-id="element-100">{`
        @keyframes progress-stripes {
          from { background-position: 20px 0; }
          to { background-position: 0 0; }
        }
      `}</style>
    </section>;
}